import React from 'react'
import { Form, Input } from 'antd'
import { useTranslation } from 'react-i18next'
import TranslateFields, { TranslationFields } from '../../../../../components/Form/TranslateFields'

export interface GroupFormValues extends Partial<TranslationFields> {
  name: string
}

interface GroupFormProps {
  form: any
  initialValues?: Partial<GroupFormValues>
  style?: React.CSSProperties
}

const GroupForm: React.FC<GroupFormProps> = ({ form, initialValues, style = { width: 400 } }) => {
  const { t } = useTranslation()

  return (
    <Form form={form} layout="vertical" initialValues={initialValues} style={style}>
      <Form.Item
        name="name"
        label={t('customReportPage:reportGroupName')}
        rules={[{ required: true, message: t('global:required-field') }]}
      >
        <Input placeholder={t('customReportPage:reportGroupName')} />
      </Form.Item>

      <TranslateFields />
    </Form>
  )
}

export default GroupForm
